import React from "react";

const MaintenancePage = () => {
    return (
        <div>
            <h1>We Will Be Back Soon!</h1>
            <p>The website is currently under maintenance. Please try again later.</p>
        </div>
    );
};

export default MaintenancePage;
